import React, { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import { IconMap2, IconTags } from '@tabler/icons';
import { NavList, NavItem } from './Navigation.styles';

type NavigationProps = PropsWithChildren<{}>;

function Navigation({ children, ...rest }: NavigationProps) {
  return (
    <div {...rest}>
      <NavList>
        <NavItem>
          <NavLink to="/somethings">Somethings</NavLink>
        </NavItem>
        <NavItem title="List all Tags">
          <NavLink to="/tags">
            <IconTags />
          </NavLink>
        </NavItem>
        <NavItem title="Map view">
          <NavLink to="/map">
            <IconMap2 />
          </NavLink>
        </NavItem>
      </NavList>
    </div>
  );
}

export default Navigation;
